import {setComma} from "../../utils/format";

interface BalanceAreaProps {
    className?: string;
    title?: string;
    balance?: number;
    expectedBalance?: number;
    expectedBalanceShow?: boolean
}


export const BalanceArea =  ({ className, title, balance, expectedBalance, expectedBalanceShow }: BalanceAreaProps) => {

    if (expectedBalanceShow) {
        return (
            <>
                <div className={className}>
                    <div className="info-row">
                        <span className="label">{title}</span>
                        <span
                            className="amount">{setComma(Number(balance))}원</span>
                    </div>
                    <div className="info-row">
                        <span className="line-label">예정잔액</span>
                        <span className="small-amount">{setComma(Number(expectedBalance))}원</span>
                    </div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div className={className}>
                    <span className="label">{title}</span>
                    <span className="amount">{setComma(Number(balance))}원</span>
                </div>
            </>
        );
    }
};